import BaseRequest from '@r1-frontend/do-request/core/BaseRequest';
import { IBaseRequest, TBaseUrl, TResponse } from '@r1-frontend/do-request/core/types';
import { BaseErrorBody } from '@r1-frontend/do-request/error/baseErrorBody';

import { IRequest } from '@r1-frontend/shared/types/IRequest';

class BaseFetchRequest extends BaseRequest implements IBaseRequest<IRequest> {
    constructor() {
        super();
    }

    public async doRequest<ResponseData>(
        urls: TBaseUrl,
        request: IRequest,
    ): Promise<TResponse<ResponseData, BaseErrorBody>> {
        const baseURL = this.getBaseUrl(urls);
        const requestConfig = this.getConfig(request);

        try {
            const { uri, queryParams } = request;

            const params = new URLSearchParams(queryParams);

            const response = await fetch(
                `${baseURL}${uri}?${params}`,
                requestConfig,
            );
            const payload = await response.json();

            return {
                isSuccess: true,
                payload,
            };
        } catch (e) {
            return {
                isSuccess: false,
                error: {
                    code: '',
                    message: e.message,
                    unparsed: e,
                },
            };
        }
    }

    private getConfig(request: IRequest): RequestInit {
        const { headers, method, body, withAuth, withProvider } = request;

        const defaultHeaders = this.getDefaultHeaders(withAuth, withProvider);

        const requestConfig: RequestInit = {
            method,
            headers: {
                ...defaultHeaders,
                ...headers,
            },
        };

        if (['POST', 'PUT', 'PATCH'].includes(method)) {
            requestConfig.body = body;
        }

        return requestConfig;
    }
}

export default BaseFetchRequest;
